import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {TreeNavigator} from '@ispm/shared/bpmn-io/services/tree-navigator';
import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {ShapeFocus} from '@ispm/shared/bpmn-io/services/shape-focus';
import Selection from 'diagram-js/lib/features/selection/Selection';
import EventBus from "diagram-js/lib/core/EventBus";
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";

export class NodeNavigatorHandler implements CommandHandler {

  constructor(private elementRegistry, private treeNavigator: TreeNavigator, private selection: Selection, private shapeFocus: ShapeFocus, private eventBus: EventBus) {
  }

  postExecute(context): any {
    const nodeId = context.elementId;
    const openPanel = !!context.openPanel;
    const element = this.elementRegistry.get(nodeId);

    if (element) {
      if (ModelingUtil.getNodeIncomingConnections(element, true).length === 0) {
        this.navigateToFloatedNode(element);
      } else {
        this.navigateToNode(element);
      }
      if (openPanel) {
        this.eventBus.fire(EventType.OPEN_PANEL, {element});
      }
    } else {
      console.error('nodeId: ' + nodeId + ' not found in pathway viewer');
    }
  }

  private navigateToFloatedNode(node) {
    const neighorhoodID = node.businessObject.neighborhoodID;
    const neighbrohoodIDElement = neighorhoodID ? this.elementRegistry.get(neighorhoodID) : undefined;
    let ancestors = neighbrohoodIDElement ? ModelingUtil.getNodeAncestors(neighbrohoodIDElement) : [];
    this.treeNavigator.navigateToMainTree();
    this.navigateToNodeByAnscetors(node, ancestors);
  }

  private navigateToNode(node) {
    let ancestors = ModelingUtil.getNodeAncestors(node);
    this.treeNavigator.navigateToMainTree();
    this.navigateToNodeByAnscetors(node, ancestors);
  }

  private navigateToNodeByAnscetors(node, ancestors) {
    if (node) {
      if (ancestors.length > 0) {
        let nodes = [...ancestors, [node]]; // in case 'node' is a neighborhood head node
        this.navigateToSubTree(nodes);
        this.shapeFocus.setDefaultFocusOnShape(node);
        this.selection.select(node);

      } else {
        this.selection.select(node);
      }
    }
  }

  private navigateToSubTree(ancestors) {
    ancestors.forEach((ancestor, index) => {
      // stop navigating if the latest node is neighborhood entry
      if (index === ancestors.length - 1 && ModelingUtil.getNodeType(ancestor[0]) === NodeType.neighborhood_entry) {
        return;
      } else {
        if (this.navigateToSubTreeByEntry(ancestor[0])) {
          return;
        }
      }
    });
  }

  private navigateToSubTreeByEntry(node): boolean {
    const nodeType = ModelingUtil.getNodeType(node);
    if (nodeType === NodeType.neighborhood_entry) {
      this.treeNavigator.navigateToSubTree(node);
      return true;
    }
    return false;
  }

}


